import { statsConfigSelectors } from '../../../config';

import defaults from './defaults';

const getCurrentReport = (state) => state.playersAndTeams.report.current;

const getReportAsQueryParams = (report) => {
    const params = [];

    // Aggregate
    if (!report.isAggregate) {
        params.push('aggregate=0');
    }

    // Report
    if (report.reportName !== 'summary') {
        params.push(`report=${report.reportName}`);
    }

    // timeFrame and date or season range
    params.push(`reportType=${report.timeFrame}`);
    if (report.timeFrame === 'game' && !report.isDateRangeFromSeasons) {
        params.push(`dateFrom=${report.dateFrom}`);
        params.push(`dateTo=${report.dateTo}`);
    } else {
        params.push(`seasonFrom=${report.seasonFrom}`);
        params.push(`seasonTo=${report.seasonTo}`);
    }

    if (report.timeFrame === 'game' && report.isDateRangeFromSeasons) {
        params.push(`dateFromSeason`);
    }

    // Game type
    params.push(`gameType=${report.gameTypeId}`);

    // Position
    if (report.positionCode) {
        params.push(`position=${report.positionCode}`);
    }

    // Franchise
    if (report.franchiseId) {
        params.push(`playerPlayedFor=${report.franchiseId}`);
    }

    return params;
};

const clearFilterDefaults = (statsConfig, reportName, timeFrame) => ({
    ...defaults,
    ...statsConfigSelectors.getReport(statsConfig, reportName),
    ...statsConfigSelectors.getTimeFrameReportData(timeFrame, statsConfig.seasonData),
});

export default {
    getCurrentReport,
    getReportAsQueryParams,
    clearFilterDefaults,
};
